import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { SupportPageItem } from '../../support/util/getSupportUrl';
import { naviagtionItems } from './naviagtionItems';

export type NavTabItem = {
  id: string | number;
  code?: string | number;
  pathName?: string;
  label: string;
  href?: string;
  isActive: boolean;
  isVisible: boolean;
  onClick?: () => void;
};

export type ActiveTab = { code?: string | number };

export function useHeaderNavigationState(
  profilePageItems: NavTabItem[] | undefined,
  supportPageItems: SupportPageItem[] | undefined
) {
  const { t } = useTranslation();
  const [isMiddleBarVisible, setIsMiddleBarVisible] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState(naviagtionItems.library.items[0]);
  const [activeTab, setActiveTab] = useState<ActiveTab | undefined>(undefined);
  const [activeItemTabs, setActiveItemTabs] = useState<NavTabItem[] | undefined>(undefined);
  const { pathname } = useLocation();

  const navigationLibraryItems = naviagtionItems.library.items.map((item) => ({
    id: item.code,
    label: t(`nav.pages.${item.code}`),
    href: `/${item.code}/library`,
    isActive: false,
    isVisible: true,
  }));

  useEffect(() => {
    const activeNavItemFromPath = naviagtionItems.library.items.find((item) =>
      pathname.includes(item.code)
    );

    if (activeNavItemFromPath) {
      setActiveNavItem(activeNavItemFromPath);

      if (activeNavItemFromPath.code === 'for-you') {
        setIsMiddleBarVisible(true);
        setActiveItemTabs(undefined);
      }
    } else {
      setActiveNavItem(undefined);
    }

    if (activeNavItemFromPath?.tabs) {
      const newTabsLinks = [
        {
          id: 'content',
          pathName: 'library',
          label: t('nav.pages.content'),
          href: `/${activeNavItemFromPath.code}/library`,
          isActive: false,
          isVisible: activeNavItemFromPath?.tabs.showContent,
        },
        {
          id: 'results',
          pathName: 'results',
          label: t('nav.pages.results'),
          href: `/${activeNavItemFromPath.code}/results`,
          isActive: false,
          isVisible: activeNavItemFromPath?.tabs.showResults,
        },
        {
          id: 'challenge',
          pathName: 'challenge',
          label: t('nav.pages.challenge'),
          href: `/${activeNavItemFromPath.code}/challenge`,
          isActive: false,
          isVisible: activeNavItemFromPath?.tabs.showChallenges,
        },
      ];

      setActiveItemTabs(newTabsLinks);

      const activeTabFromPath = newTabsLinks.find((item) => pathname.includes(item.pathName));
      if (activeTabFromPath) {
        setActiveTab({ code: activeTabFromPath.id });
      }
    } else if (pathname.includes('profile') && profilePageItems) {
      setActiveItemTabs(profilePageItems);
      const activeTabFromPath = profilePageItems.find((item) => item.isActive);
      if (activeTabFromPath) {
        setActiveTab(activeTabFromPath);
      }
    } else if (pathname.includes('support') && supportPageItems) {
      setActiveItemTabs(supportPageItems);
    }
  }, [profilePageItems, pathname, supportPageItems, t]);

  return {
    activeItemTabs,
    activeNavItem,
    activeTab,
    isMiddleBarVisible,
    navigationLibraryItems,
    setIsMiddleBarVisible,
  };
}
